module.exports = __webpack_public_path__ + "img/img-1.6b3ea02c.jpg";